import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, CircularProgress} from 'views/components';

import WeeklySlip from './WeeklySlip';
import RegenerateInvoice from './RegenerateInvoice';

const Payment = (props) => {
  const clientRn = props.clientRn;
  const refresh = props.refresh;
  const clientBackend = props.clientBackend;
  const clientPaymentSlip = props.clientPaymentSlip;
  const clientPaymentSlipLoading = props.clientPaymentSlipLoading;

  React.useEffect(() => {
    clientBackend.payment.loadPaymentSlips();
  }, [clientRn, refresh]);

  if (clientPaymentSlipLoading) {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 2,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Stack
      sx={{
        p: 2,
      }}
      spacing={1}
    >
      <RegenerateInvoice clientBackend={clientBackend} />
      {
        Object.values(clientPaymentSlip).map((e, index) => {
          return (
            <WeeklySlip
              key={e.weekOf}
              slipDetail={e}
              clientBackend={clientBackend}
            />
          );
        })
      }
    </Stack>
  );
};

Payment.propTypes = {
  refresh: PropTypes.number.isRequired,
  clientRn: PropTypes.string.isRequired,
  clientBackend: PropTypes.object.isRequired,
  clientPaymentSlip: PropTypes.object.isRequired,
  clientPaymentSlipLoading: PropTypes.bool.isRequired,
};
export default React.memo(Payment);
